import { Component, OnInit } from '@angular/core';
  ///IDIOMAS
import { Subject } from 'rxjs';
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import *  as $ from 'jquery';
import {TranslateService} from '@ngx-translate/core';
export interface Section {
  name: string;

}

@Component({
  selector: 'app-guia4',
  templateUrl: './guia4.component.html',
  styleUrls: ['./guia4.component.scss']
})
export class Guia4Component implements OnInit {
  private _unsubscribeAll: Subject<any>;
  folders: Section[] = [
    {
      name:"15-19"
    },{
      name:"20-24"
    },{
      name:"25-29"
    },{
      name:"30-34"
    },{
      name:"35-39"
    },{
      name:"40-44"
    }
  ];
  folders2: Section[] = [
    {
      name:"45-49"
    },{
      name:"50-54"
    },{
      name:"55-59"
    },{
      name:"60-74"
    },{
      name:"75-69"
    },{
      name:"70-44"
    }
  ];

  estado1: Section[] = [
    {
      name:"Casado"
    },{
      name:"soltero"
    },{
      name:"Unión Libre"
    }
  ];

  estado2: Section[] = [
    {
      name:"Divorciado"
    },{
      name:"Viudo"
    },{
      name: ""
    }
  ];

  nivelEstudios = [
     {
      nombre:"WIZARD.Guia5.CONTENT.ESTUDIOS.LABEL02",
    }, {
      nombre:"WIZARD.Guia5.CONTENT.ESTUDIOS.LABEL03",
    },{
      nombre: "WIZARD.Guia5.CONTENT.ESTUDIOS.LABEL04",
    },{
      nombre: "WIZARD.Guia5.CONTENT.ESTUDIOS.LABEL05",
    },{
      nombre: "WIZARD.Guia5.CONTENT.ESTUDIOS.LABEL06",
    },{
      nombre: "WIZARD.Guia5.CONTENT.ESTUDIOS.LABEL07",
    },{
      nombre: "WIZARD.Guia5.CONTENT.ESTUDIOS.LABEL08",
    }
  ]



  constructor(private _fuseTranslationLoaderService: FuseTranslationLoaderService,private translateSrv: TranslateService) {
    this._unsubscribeAll = new Subject();
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaBanner(this.translateSrv.currentLang); });
   }

  ngOnInit() {
    $(window).scrollTop();
    this.cambiaIdiomaBanner(this.translateSrv.currentLang);
  }

  idiomaBanner:any;
  cambiaIdiomaBanner(idioma:string){
    this.idiomaBanner = this.translateSrv.currentLang; 
    switch(idioma){
      case 'es': this.idiomaBanner = idioma; 
      break;
      default: this.idiomaBanner = 'en';
    }
    this.getBanner();
  }
  urlBanner:any;
  getBanner(){
    this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-12.png';
  }

}
